export const TOGGLE_ALLOW_COOKIE_RESET = 'toggle-allow-cookie-reset';
export const TOGGLE_RAW_HTML = 'toggle-raw-html';
export const TOGGLE_MARKETING_CONTACT = 'toggle-marketing-contact';
export const TOGGLE_PREPOPULATE_CONTACT = 'toggle-prepopulate-contact';
export const TOGGLE_PAYMENTS = 'toggle-payments';
export const PAYMENT_CHANGED = 'payment-changed';
export const PREVIEWED_PAYMENTS_LINK = 'previewed-payments-link';
export const INCOMPLETE_SETUP_GO_TO_OPTIONS = 'incomplete-setup-go-to-options';
export const SET_CUSTOM_LIFECYCLE_STAGE = 'set-custom-lifecycle-stage';
export const RESET_CUSTOM_LIFECYCLE_STAGE = 'reset-custom-lifecycle-stage';
export const TRANSLATE_FORM_FROM_OPTIONS = 'translate-form-from-options';
export const UPDATE_POST_SUBMISSION_OPTION = 'update-post-submission-option';
export const TOGGLE_NOTIFY_HUBSPOT_OWNER = 'toggle-notify-hubspot-owner';

//forms routing keys
export const ROUTING_ADD_FIELD = 'routing-add-field';
export const ROUTING_ADD_CONDITION = 'routing-add-condition';
export const ROUTING_SELECT_REDIRECT_TYPE = 'routing-select-redirect-type';
export const ROUTING_SELECT_FALLBACK_TYPE = 'routing-select-fallback-type';
export const ROUTING_CONDITION_SET = 'routing-condition-set';